import { IConvertedSession, ICreateSessionPayload } from 'shared/models/Upgaming'
import { makeCommunicationActionCreator } from 'shared/utils/communication/actions/makeCommunicationActionCreator'

export const createSession = makeCommunicationActionCreator({
  loading: '@upgaming/CREATE_SESSION_LOADING',
  success: '@upgaming/CREATE_SESSION_SUCCESS',
  error: '@upgaming/CREATE_SESSION_ERROR',
  reset: '@upgaming/CREATE_SESSION_RESET',
})<ICreateSessionPayload, IConvertedSession>(
  async ({
    deps: {
      extra: { api },
    },
    payload,
  }) => {
    const response = await api.upgaming.createSession(payload)
    return response.data
  },
)

export const createGuestSession = makeCommunicationActionCreator({
  loading: '@upgaming/CREATE_GUEST_SESSION_LOADING',
  success: '@upgaming/CREATE_GUEST_SESSION_SUCCESS',
  error: '@upgaming/CREATE_GUEST_SESSION_ERROR',
  reset: '@upgaming/CREATE_GUEST_SESSION_RESET',
})<ICreateSessionPayload, IConvertedSession>(
  async ({
    deps: {
      extra: { api },
    },
    payload,
  }) => {
    const response = await api.upgaming.createGuestSession(payload)
    return response.data
  },
)
